import useSWR from "swr"

import fetchProductReviewsByProductId from "@secureo/common/utils/commerceTools/graphql/queries/fetchProductReviewsByProductId"

import { Review } from "@secureo/common/typings/Product"

const useProductReviews = (accessToken: string, productId: string, fallbackData: Review[] = []) => {
	const { data: reviews, error } = useSWR(
		accessToken && productId ? [accessToken, productId] : null,
		([accessToken, productId]) => fetchProductReviewsByProductId(accessToken, productId),
		{
			fallbackData,
			revalidateOnMount: true,
		},
	)

	return {
		reviews,
		error,
	}
}

export default useProductReviews
